export enum UploadedFileBucket {
	Storage = "Storage",
	Upload = "Upload",
}
